<template>
  <div class="overflow-x-hidden pb-4">
    <div class="py-4 position-relative overflow-hidden px-0">
      <div
        class="container text-left overflow-hidden position-relative"
        style="max-width: 1200px; z-index: 2"
      >
        <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex mb-12 mb-md-8">
          <router-link class="mr-6 grey--text text--darken-4" style="border-bottom: 2px solid #2e3c55" to="/">
            Home
          </router-link>
          <router-link class="mr-6 grey--text text--darken-4" to="/search">Search</router-link>
          <button @click="views.whatsapp = true" class="mr-6 grey--text text--darken-4">Whatsapp</button>
          <button @click="gotoOrder()" class="mr-6 grey--text text--darken-4">Order</button>
        </div>
        <div :style="{maxWidth: `${$vuetify.breakpoint.mdAndDown ? '320px' : '100%'}`}" class="mt-2 mt-md-10">
          <div class="banner-title black--text font-weight-bold pr-5 d-flex align-center pr-12 pr-md-0">
            Pay later from 50,000 merchants
          </div>
          <div class="body-1 black--text d-flex flex-column mt-2 pr-16 pr-md-0">
            Connect with credit stores from Instagram, Jiji, Jumia, Konga, etc
          </div>
          <v-btn
            @click="$bus.$emit('modal', 'search')" color="primary" class="mt-6" elevation="0"
            style="border-radius: 8px"
          >
            Start shopping
          </v-btn>
        </div>
      </div>
      <div class="absolute right top" style="transform: translate(40%, 10px); opacity: .7">
        <img src="/img/instagram-phone-half.png" alt="ig phone"/>
      </div>
    </div>

    <div class="container--fluid px-4 py-4 bottom-nav-spacing">
      <swiper :options="swiperOptions" ref="el">
        <template v-for="(category, i) in categories">
          <swiper-slide :key="category.id">
            <v-responsive :aspect-ratio="9/11">
              <router-link :to="`/search?q=${ category.keyword }`">
                <v-card
                  class="fill-height position-relative" outlined
                  :img="category.image || `https://picsum.photos/200/${300 + i}`"
                >
                  <v-card-text
                    class="d-flex flex-column fill-height pa-6 white--text py-8"
                    style="background: rgba(0, 0, 0, .3)"
                  >
                    <h3 class="white--text font-weight-bold" style="font-size: 1.5rem">{{ category.name }}</h3>
                    <p class="white--text text-body-1 mt-3">1,000+ merchants</p>
                    <div class="mt-auto text-right">
                      <v-icon size="100" color="gray">mdi-cart</v-icon>
                    </div>
                    <v-img
                      class="absolute bottom left mb-4 ml-6" src="@/assets/images/logo-icon.png" width="40"
                      style="opacity: .3"
                    />
                  </v-card-text>
                </v-card>
              </router-link>
            </v-responsive>
          </swiper-slide>
        </template>
      </swiper>
    </div>

    <SpeedDial/>

    <StandaloneBottomNav/>

    <v-navigation-drawer
      v-if="!$vuetify.breakpoint.smAndDown" fixed right temporary v-model="views.noOrder" width="550"
    >
      <NoOrderFound @close="views.noOrder = false"/>
    </v-navigation-drawer>
  </div>
</template>

<script>
import StandaloneBottomNav from "@/components/standalone/StandaloneBottomNav";
import categories from "@/lib/categories.js";
import SpeedDial from "@/components/SpeedDial.vue";
import NoOrderFound from "@/components/NoOrderFound.vue";

export default {
  name: "Home",
  components: { NoOrderFound, SpeedDial, StandaloneBottomNav },
  data() {
    return {
      categories,
      current: null,
      swiperOptions: {
        slidesPerView: 1.3,
        spaceBetween: 15,
        breakpoints: {
          640: {
            slidesPerView: 2.5
          },
          700: {
            slidesPerView: 3.5
          },
          900: {
            slidesPerView: 4.5
          }
        },
        loop: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        speed: 6000
      },
      views: {
        list: true,
        search: false,
        noOrder: false
      }
    }
  },
  methods: {
    gotoOrder() {
      const slug = localStorage.getItem('request') || this.$store.state.request.global_request_id;
      if (slug) this.$router.push(`/request/${ slug }`)
      else this.views.noOrder = true;
    }
  }
}
</script>
